import { generatePath, Link } from "react-router-dom";

interface IEndpointOverviewStatWrapperProps {
  workspaceId: string;
  title: string;
  amount: number;
  path?: string;
}

export const EndpointOverviewStatWrapper = ({
  workspaceId,
  title,
  amount,
  path,
}: IEndpointOverviewStatWrapperProps) => {
  return (
    <Link
      to={path ? generatePath(path, { workspaceId }) : "."}
      className="p-4 flex flex-col gap-2 bg-white shadow-xs border border-gray-v2-200 rounded-xl no-underline"
    >
      <span className="text-sm font-medium text-gray-v2-600">{title}</span>
      <span className="text-display-sm font-semibold text-gray-v2-900">
        {amount}
      </span>
    </Link>
  );
};
